import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-down-left', 'ChevronDownLeft', [["path",{"d":"M8 8v8h8"}]]);